'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BitbucketIconIcon = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Icon = require('../lib/Icon');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BitbucketIconIcon = exports.BitbucketIconIcon = function BitbucketIconIcon(props) {
  var _prepareProps = (0, _Icon.prepareProps)(props),
      title = _prepareProps.title,
      iconProps = _prepareProps.iconProps;

  return _react2.default.createElement(
    'svg',
    (0, _extends3.default)({ width: '24', height: '24', viewBox: '0 0 24 24', focusable: 'false' }, iconProps, { 'aria-labelledby': 'title-j7so2k6' }),
    _react2.default.createElement(
      'title',
      { id: 'title-j7so2k6' },
      title
    ),
    _react2.default.createElement('path', { d: 'M17.026 15.25c-.106 0-.191.074-.191.074s-1.724 1.356-4.84 1.356c-3.115 0-4.84-1.356-4.84-1.356s-.085-.075-.19-.075c-.128 0-.249.085-.249.272 0 .02.002.04.006.06.268 1.421.463 2.43.497 2.584C7.453 19.21 9.513 20 11.995 20c2.482 0 4.542-.79 4.776-1.835.034-.154.23-1.163.497-2.585a.317.317 0 0 0 .006-.059c0-.187-.12-.272-.248-.272zM12 4C8.147 4 5 5.029 5 6.306c0 .336.84 5.16 1.174 7.074.15.858 2.382 2.116 5.824 2.116l.004-.01v.01c3.442 0 5.675-1.258 5.824-2.116C18.16 11.467 19 6.642 19 6.306 19 5.029 15.853 4 12 4zm0 9.946a2.217 2.217 0 0 1-2.225-2.21c0-1.22.996-2.21 2.225-2.21s2.225.99 2.225 2.21-.996 2.21-2.225 2.21zm1.066-2.248c0 .611-.499 1.107-1.115 1.107a1.111 1.111 0 0 1-1.115-1.107c0-.612.5-1.107 1.115-1.107a1.11 1.11 0 0 1 1.115 1.107zM12 7.018c-2.476-.003-4.483-.43-4.482-.954.001-.523 2.009-.943 4.485-.94 2.476.004 4.482.431 4.481.955 0 .523-2.008.944-4.484.94z', fill: 'currentColor', fillRule: 'evenodd', role: 'presentation' })
  );
};
exports.default = (0, _Icon.iconConstructor)('BitbucketIcon', BitbucketIconIcon);


//////////////////
// WEBPACK FOOTER
// ./~/@atlaskit/icon/glyph/bitbucket.js
// module id = 351
// module chunks = 0